// import React from 'react'

import { dotmatrix, printList, printPos, wsClient } from "helper/dotmatrix";
// import { getUrl } from "libs/pdf";
// import {toJpeg} from 'libs/converter'
import moment from "moment";
import { fnumber } from "helper/Helper";
import receiptToArray from "./receiptToArray";
const EscPosEncoder = require("esc-pos-encoder");
const encoder = new EscPosEncoder();
const secureStorage = require("libs/secureStorage");

const PRINTER_PROFILES = [
  {
    service: "000018f0-0000-1000-8000-00805f9b34fb",
    characteristic: "00002af1-0000-1000-8000-00805f9b34fb",
  },
  {
    service: "0000ff00-0000-1000-8000-00805f9b34fb",
    characteristic: "0000ff02-0000-1000-8000-00805f9b34fb",
  },
  {
    service: "e7810a71-73ae-499d-8c15-faa9aef0c3f2",
    characteristic: "bef8d6c9-9c21-4c9e-b632-bd58c1009f9f",
  },
  {
    service: "49535343-fe7d-4ae5-8fa9-9fafd205e455",
    characteristic: "49535343-8841-43f4-a8d4-ecbe34729bb3",
  },
];

const sendToBluetooth = (receipt) => {
  if (!navigator.bluetooth)
    throw Error("Perangkat ini tidak mendukung bluetooth");

  const sendChunks = async (chara) => {
    const maxSize = 20;
    let index = 0;
    const useWithoutResponse =
      chara.properties.writeWithoutResponse && !chara.properties.write;
    while (index < receipt.byteLength) {
      const chunk = receipt.slice(index, index + maxSize);
      if (useWithoutResponse) {
        await chara.writeValueWithoutResponse(chunk);
      } else {
        await chara.writeValue(chunk);
      }
      index += maxSize;
      await new Promise((resolve) => setTimeout(resolve, 200));
    }
  };

  const tryProfile = async (server, profile) => {
    const service = await server.getPrimaryService(profile.service);
    const chara = await service.getCharacteristic(profile.characteristic);
    if (!chara.properties.write && !chara.properties.writeWithoutResponse) {
      throw new Error("Characteristic not writable");
    }
    return chara;
  };

  navigator.bluetooth
    .requestDevice({
      acceptAllDevices: true,
      optionalServices: PRINTER_PROFILES.map((p) => p.service),
    })
    .then((device) => device.gatt.connect())
    .then(async (server) => {
      for (const profile of PRINTER_PROFILES) {
        try {
          const chara = await tryProfile(server, profile);
          await sendChunks(chara);
          return;
        } catch (_) {}
      }
      throw Error(
        "Printer tidak dikenali. Pastikan printer menyala dan terpasang dengan benar."
      );
    })
    .catch((err) => {
      alert(err.message);
      return false;
    });
};

const formatPrintThermal = (payload, collective) => {
  console.log({ payload });
  const user = secureStorage.getItem("account");
  const info = secureStorage.getItem("domainInfo");

  const payloads = Array.isArray(payload) ? payload : [payload];

  const rowsToText = (rows) => {
    const WIDTH = 32;
    const LABEL_W = 13;
    const SEP = ": ";
    const VAL_W = WIDTH - LABEL_W - SEP.length;
    const INDENT = " ".repeat(LABEL_W + SEP.length);

    const wrapValue = (value) => {
      const lines = [];
      const words = value.split(" ");
      let current = "";
      for (const word of words) {
        if ((current ? current + " " + word : word).length <= VAL_W) {
          current = current ? current + " " + word : word;
        } else {
          if (current) lines.push(current);
          current = word.length > VAL_W ? word.substring(0, VAL_W) : word;
        }
      }
      if (current) lines.push(current);
      return lines;
    };

    let text = "";
    for (const item of rows) {
      let line;
      if (!Array.isArray(item)) {
        line = item;
      } else if (item.length === 1) {
        line = item[0];
      } else {
        const label = item[0].toString().padEnd(LABEL_W);
        const isNumber = typeof item[1] === "number";
        let value;
        if (item[0] === "TGL TRANSAKSI") {
          value = moment(item[1]).format("DD/MM/YY HH:mm");
        } else if (isNumber) {
          value = "Rp." + fnumber(item[1]);
        } else {
          value = String(item[1] ?? "");
        }

        if (value.length <= VAL_W) {
          line = label + SEP + (isNumber ? value.padStart(VAL_W) : value);
        } else {
          const wrapped = wrapValue(value);
          line = label + SEP + wrapped[0];
          for (let i = 1; i < wrapped.length; i++) {
            line += "\n" + INDENT + wrapped[i];
          }
        }
      }
      text += line + "\n";
    }
    return text;
  };

  const appendFooter = (rows, p) => {
    if (p.productId === 14) {
      rows.push(["PLN menyatakan struk ini sebagai"]);
      rows.push(["bukti pembayaran yang sah"]);
    }
    rows.push([`Loket : ${user.name}`]);
    rows.push([`Powered by ${info ? info.appName : ""}`]);
  };

  const result = [];

  for (const p of payloads) {
    const title = p.receiptTitle || p.title;
    const body = p.body; // || p.receiptBody;
    const isMultiDetail = body.details && body.details.length > 0;

    if (!isMultiDetail) {
      const rows = receiptToArray(body);
      appendFooter(rows, p);
      result.push({ title, text: rowsToText(rows) });
    } else {
      const adminPerDetail = (body.admin?.value ?? 0) / (body.qty?.value || 1);
      body.details.forEach((detail) => {
        const rows = [];
        for (const key of Object.keys(body)) {
          if (["period", "standMeter", "qty"].includes(key)) continue;
          if (key === "details") {
            Object.keys(detail).forEach((dKey) => {
              if (["dueAmount", "penalty", "tax"].includes(dKey)) return;
              const field = detail[dKey];
              if (!field) return;
              rows.push([field.caption, field.value]);
            });
            continue;
          }
          if (key === "amount") {
            const amountPerDetail =
              (detail.dueAmount?.value ?? 0) +
              (detail.penalty?.value ?? 0) +
              (detail.tax?.value ?? 0);
            rows.push([body.amount.caption, amountPerDetail]);
          } else if (key === "admin") {
            rows.push([body.admin.caption, adminPerDetail]);
          } else if (key === "total") {
            const totalPerDetail =
              (detail.dueAmount?.value ?? 0) +
              (detail.penalty?.value ?? 0) +
              (detail.tax?.value ?? 0) +
              adminPerDetail;
            rows.push([body.total.caption, totalPerDetail]);
          } else if (key === "info") {
            rows.push([body[key]?.value]);
          } else {
            rows.push([body[key]?.caption, body[key]?.value]);
          }
        }
        appendFooter(rows, p);
        result.push({ title, text: rowsToText(rows) });
      });
    }
  }

  // const wholeLine = result
  //   .map(({ title: t, text }) => `${t}\n${text}`)
  //   .join("\n\n");
  // console.log(wholeLine);

  const encoded = result.map(({ title: t, text }) =>
    encoder
      .initialize()
      .align("center")
      .bold(true)
      .line(t)
      .bold(false)
      .align("left")
      .newline()
      .line(text)
      .newline()
      .newline()
      .cut("partial")
      .encode()
  );

  const totalLength = encoded.reduce((sum, r) => sum + r.byteLength, 0);
  const receipt = new Uint8Array(totalLength);
  let offset = 0;
  for (const r of encoded) {
    receipt.set(new Uint8Array(r.buffer), offset);
    offset += r.byteLength;
  }

  sendToBluetooth(receipt);
};

const printThermal = (payload) => {
  //let receipt = encoder.initialize()
  const user = secureStorage.getItem("account");
  const info = secureStorage.getItem("domainInfo");
  // console.log({ user, info });
  const title = payload.title;
  const body = !Array.isArray(payload.body)
    ? receiptToArray(payload.body)
    : payload.body;

  payload.productId === 14 &&
    body.push(["PLN menyatakan struk ini sebagai bukti pembayaran yang sah"]);
  body.push([`Loket : ${user.name}`]);
  body.push([`Powered by ${info ? info.appName : ""}`]);
  // const spaceLength = spaceNum(payload.body)
  let wholeLine = "";
  for (const item of body) {
    const line = Array.isArray(item)
      ? item.length > 1
        ? item[0].toString().padEnd(15, " ") +
          ": " +
          (typeof item[1] !== "number"
            ? item[0] === "TGL TRANSAKSI"
              ? // ? item[1]
                moment(item[1]).format("DD/MM/YY HH:mm")
              : item[1]
            : "Rp. " + fnumber(item[1]).padStart(9, " "))
        : item[0]
      : item;
    wholeLine += line + "\n";
    //receipt.line(line)
  }

  // console.log(wholeLine);
  const receipt = encoder
    .initialize()
    .newline("center")
    .bold(true)
    .text(title)
    .bold(false)
    .align("left")
    .newline()
    .newline()
    .line(wholeLine)
    .newline()
    .newline()
    .cut("partial")
    .encode();
  if (navigator.bluetooth) {
    // navigator.bluetooth
    //   .requestDevice({
    //     acceptAllDevices: true,
    //     // optionalServices: ["000018f0-0000-1000-8000-00805f9b34fb"],
    //   })
    //   .then((device) => {
    //     return device.gatt.connect();
    //   })
    //   .then((server) => {
    //     return server.getPrimaryServices();
    //   })
    //   .then((services) => {
    //     if (services.length > 0) {
    //       return services[0].getCharacteristics();
    //     } else throw Error("Service not support");
    //   })
    //   .then((characteristics) => {
    //     const chara = characteristics.find((char) => char.properties.write);
    //     if (!chara) throw Error("Device not support");
    //     return chara;
    //   })
    //   .then(async (chara) => {
    //     const maxSize = 20;
    //     let chunkCount = Math.ceil(receipt.byteLength / maxSize);
    //     let index = 0;
    //     const sendChunk = () => {
    //       if (!chunkCount) {
    //         return;
    //       }
    //       const chunk = receipt.slice(index, index + maxSize);
    //       index += maxSize;
    //       chunkCount--;
    //       chara.writeValue(chunk);
    //       setTimeout(() => {
    //         sendChunk();
    //       }, 200);
    //     };
    //     sendChunk();
    //   })
    //   .catch((err) => {
    //     alert(err.message);
    //     return false;
    //   });
    // BACK
    // navigator.bluetooth
    //   .requestDevice({
    //     acceptAllDevices: true,
    //     optionalServices: ["000018f0-0000-1000-8000-00805f9b34fb"],
    //   })
    //   .then((device) => {
    //     return device.gatt.connect();
    //   })
    //   .then((server) => {
    //     return server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb");
    //   })
    //   .then((service) => {
    //     return service.getCharacteristic(
    //       "00002af1-0000-1000-8000-00805f9b34fb"
    //     );
    //   })
    //   .then(async (chara) => {
    //     const maxSize = 20;
    //     let chunkCount = Math.ceil(receipt.byteLength / maxSize);
    //     let index = 0;
    //     const sendChunk = () => {
    //       if (!chunkCount) {
    //         return;
    //       }
    //       const chunk = receipt.slice(index, index + maxSize);
    //       index += maxSize;
    //       chunkCount--;
    //       chara.writeValue(chunk);
    //       setTimeout(() => {
    //         sendChunk();
    //       }, 200);
    //     };
    //     sendChunk();
    //   })
    //   .catch((err) => {
    //     alert("[BT Error] " + err.message);
    //     return false;
    //   });
    // Known BLE printer service/characteristic profiles
    const PRINTER_PROFILES = [
      {
        // HPRT, Xprinter, dan sebagian besar printer thermal China
        service: "000018f0-0000-1000-8000-00805f9b34fb",
        characteristic: "00002af1-0000-1000-8000-00805f9b34fb",
      },
      {
        // Rongta, iDPRT, Odi, dan OEM sejenis
        service: "0000ff00-0000-1000-8000-00805f9b34fb",
        characteristic: "0000ff02-0000-1000-8000-00805f9b34fb",
      },
      {
        // Epson TM mobile series
        service: "e7810a71-73ae-499d-8c15-faa9aef0c3f2",
        characteristic: "bef8d6c9-9c21-4c9e-b632-bd58c1009f9f",
      },
      {
        // Woosim, Bixolon, dan beberapa printer SPP-over-BLE
        service: "49535343-fe7d-4ae5-8fa9-9fafd205e455",
        characteristic: "49535343-8841-43f4-a8d4-ecbe34729bb3",
      },
    ];
    const sendChunks = async (chara) => {
      const maxSize = 20;
      let index = 0;
      const useWithoutResponse =
        chara.properties.writeWithoutResponse && !chara.properties.write;
      while (index < receipt.byteLength) {
        const chunk = receipt.slice(index, index + maxSize);
        if (useWithoutResponse) {
          await chara.writeValueWithoutResponse(chunk);
        } else {
          await chara.writeValue(chunk);
        }
        index += maxSize;
        await new Promise((resolve) => setTimeout(resolve, 200));
      }
    };
    const tryProfile = async (server, profile) => {
      const service = await server.getPrimaryService(profile.service);
      const chara = await service.getCharacteristic(profile.characteristic);
      if (!chara.properties.write && !chara.properties.writeWithoutResponse) {
        throw new Error("Characteristic not writable");
      }
      return chara;
    };
    navigator.bluetooth
      .requestDevice({
        acceptAllDevices: true,
        optionalServices: PRINTER_PROFILES.map((p) => p.service),
      })
      .then((device) => device.gatt.connect())
      .then(async (server) => {
        for (const profile of PRINTER_PROFILES) {
          try {
            const chara = await tryProfile(server, profile);
            await sendChunks(chara);
            return;
          } catch (_) {
            // profile ini tidak cocok, coba berikutnya
          }
        }
        throw Error(
          "Printer tidak dikenali. Pastikan printer menyala dan terpasang dengan benar."
        );
      })
      .catch((err) => {
        alert(err.message);
        return false;
      });
  } else {
    throw Error("Perangkat ini tidak mendukung bluetooth");
  }
};
const printDotMatrix = (payload, collective) => {
  dotmatrix(payload, collective);
};

const printDeskjet = async (payload) => {
  const { getUrl } = require("libs/pdf");
  const url = await getUrl(payload, "PdfReceipt");
  if (navigator.userAgent.toLocaleLowerCase().indexOf("electron/") !== -1) {
    wsClient.send("deskjet", { url });
  } else {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
};
const printDeskjetList = async (payload) => {
  // const {title,body} = payload
  const url = payload.url;
  if (navigator.userAgent.toLocaleLowerCase().indexOf("electron/") !== -1) {
    wsClient.send("deskjet", { url });
  } else {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
};
const printDeskjetCollective = async (payload) => {
  // console.log(payload)
  const { getUrl } = require("libs/pdf");
  const data = payload;
  const url = await getUrl({ data }, "PdfCollective");
  if (navigator.userAgent.toLocaleLowerCase().indexOf("electron/") !== -1) {
    wsClient.send("deskjet", { url });
  } else {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
};

const print = (payload, collective) => {
  const printer = secureStorage.getItem("printer");

  // formatPrintThermal(payload, collective);
  if (printer === "thermal") formatPrintThermal(payload, collective);
  else if (printer === "dotmatrix") printDotMatrix(payload, collective);
  else if (printer === "pos") printPos(payload);
  else {
    if (!collective) printDeskjet(payload);
    else printDeskjetCollective(payload);
  }
};
print.list = (payload) => {
  if (payload.printer === "dotmatrix") printList(payload);
  else printDeskjetList(payload);
};

export default print;
